import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-gradient-to-br from-[#2D2A3E] via-[#3A2F4A] to-[#2D2A3E] px-4 text-center relative overflow-hidden" data-id="element-52">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#C4973B]/10 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" data-id="element-53"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#C06B6B]/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" data-id="element-54"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#B8A9C9]/5 rounded-full blur-3xl" data-id="element-55"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-56">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-57">
          ⚡ La verdad final
        </h2>

        <div className="prose prose-lg prose-invert mx-auto mb-12 text-white/90" data-id="element-58">
          <p data-id="element-59">
            Mientras tu sistema nervioso no se regule, nada se sostiene: ni tus
            relaciones, ni tu descanso, ni tu calma real.
          </p>
          <p className="font-bold text-white text-xl" data-id="element-60">
            👉 Esto no es un ebook. 👉 Es tu salida del modo supervivencia.
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-[#C4973B]/20 shadow-2xl" data-id="element-61">
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-62">
            Tu cuerpo lleva años pidiéndolo en silencio.
          </h3>
          <p className="text-white/75 mb-8 text-lg font-medium text-[#C4973B]" data-id="element-63">
            🌿 Empieza tu primera sesión ahora
          </p>

          <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-gradient-to-r from-[#C4973B] to-[#D4A84C] text-white font-bold text-xl py-5 px-10 rounded-full shadow-xl shadow-[#C4973B]/30 hover:shadow-2xl hover:shadow-[#C4973B]/40 hover:scale-105 transition-all flex items-center justify-center gap-3 mx-auto group" data-id="element-64">
            👉 Escuchar mi sesión de 5 minutos
            <ArrowRight className="h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-65" />
          </a>

          <p className="mt-6 text-sm text-white/50" data-id="element-66">
            Acceso inmediato • Pago único • Garantía incluida
          </p>

          <p className="mt-8 text-white/90 font-serif italic text-lg" data-id="element-67">
            "No lo pienses. Respíralo."
          </p>
        </div>
      </div>
    </section>;
}